<div class="mb-2 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 bg-zinc-100 dark:bg-zinc-900">
  <div>
    <!-- <button routerLink="add/" class="btn btn-primary">
        Add Company
    </button> -->
  </div>
  <div *ngIf="filteredcompanies">
    <h1 class="text-xs text-nowrap text-left">Showing {{(50 * currentPage) - (filteredcompanies.length != 50? (50
      -filteredcompanies.length) : 0) }} of {{totalResults }} entries
    </h1>
  </div>
  <div class="relative">
    <input type="text" [(ngModel)]="search" placeholder="Search.." class="pl-8" />
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
      class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
    </svg>
  </div>
</div>
<div class="mt-2 pb-6 p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
  <div class="overflow-x-auto">
    <table class="min-w-full table-auto border-collapse border  border-zinc-950/10 dark:border-white/10">
      <thead class="bg-zinc-950/5 dark:bg-white/5">
        <tr>
          <th
          class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
            Action                     
        </th>
          <th
            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
            Name</th>
          <th
            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
            Address</th>
          <th
            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
            Email</th>
          <th
            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
            Contact No.</th>
          <th
            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
            Created At</th>
          <th
            class="px-3 py-1 text-left font-semibold text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
            Status</th>

           
        </tr>
      </thead>
      <tbody>
        <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
          *ngFor="let item of filteredcompanies | filter: search | paginate: { itemsPerPage: numberOfRecords, currentPage: currentPage, totalItems:totalResults }">
          <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
            <div class="flex">
              <a routerLink="{{item.id}}/edit" class="px-2 text-[#1A1A1D]  duration-500 ease-linear">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                  stroke="currentColor" class="size-5 text-zinc-500 dark:text-zinc-400">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                </svg>
              </a>
            </div>
          </td>
          <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
            {{item.name}}
          </td>
          <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
            {{item.address?.name}}</td>
          <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
            {{item.email}}</td>
          <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
            {{item.contactNumber}}</td>
          <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">January
            2,2024</td>
          <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10">
            <span [ngClass]="item.isActive ? 'badge-success' : 'badge-danger'" class="">
              {{item.isActive ? 'Active' : 'Inactive'}}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="mt-2 flex justify-end">
    <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
  </div>
</div>